import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Twitter, Mail, Phone } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleNavClick = (e, href) => {
    const isHomePage = window.location.hash === '#/' || window.location.hash === '';

    if (href.startsWith('/#') && isHomePage) {
      e.preventDefault();
      const targetId = href.replace('/#', '#');
      const element = document.querySelector(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (href === '/' && isHomePage) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#202121] text-[#DBCE97] pt-16 pb-8">
      <div className="container-custom">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_2d5da32d-c8d7-4484-9889-ef5971ddb3aa/artifacts/et1hsjc0_logo%2Btexto-evolvance.png"
              alt="Evolvance"
              className="h-10 mb-4"
            />
            <p className="body-medium mb-6 max-w-md">
              {companyInfo.description}
            </p>
            <div className="flex items-center gap-4">
              <a
                href={companyInfo.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 hover:bg-[#D4AF37] flex items-center justify-center transition-all group"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5 text-[#D4AF37] group-hover:text-[#202121] transition-colors" />
              </a>
              <a
                href={companyInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 hover:bg-[#D4AF37] flex items-center justify-center transition-all group"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-[#D4AF37] group-hover:text-[#202121] transition-colors" />
              </a>
              <a
                href={companyInfo.social.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 hover:bg-[#D4AF37] flex items-center justify-center transition-all group"
                aria-label="X (Twitter)"
              >
                <img
                  src="https://img.icons8.com/?size=100&id=de4vjQ6J061l&format=png&color=D4AF37"
                  alt="X"
                  className="w-5 h-5 group-hover:brightness-0 group-hover:invert transition-all"
                />
              </a>
              <a
                href={`mailto:${companyInfo.contact.email}`}
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 hover:bg-[#D4AF37] flex items-center justify-center transition-all group"
                aria-label="Email"
              >
                <Mail className="w-5 h-5 text-[#D4AF37] group-hover:text-[#202121] transition-colors" />
              </a>
              <a
                href={`tel:${companyInfo.contact.phone.replace(/\s+/g, '')}`}
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 hover:bg-[#D4AF37] flex items-center justify-center transition-all group"
                aria-label="Phone Primary"
                title={companyInfo.contact.phone}
              >
                <Phone className="w-5 h-5 text-[#D4AF37] group-hover:text-[#202121] transition-colors" />
              </a>
              {companyInfo.contact.phoneSecondary && (
                <a
                  href={`tel:${companyInfo.contact.phoneSecondary.replace(/\s+/g, '')}`}
                  className="w-10 h-10 rounded-full bg-[#D4AF37]/10 hover:bg-[#D4AF37] flex items-center justify-center transition-all group"
                  aria-label="Phone Secondary"
                  title={companyInfo.contact.phoneSecondary}
                >
                  <Phone className="w-5 h-5 text-[#D4AF37] group-hover:text-[#202121] transition-colors opacity-70 group-hover:opacity-100" />
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-outfit text-white font-semibold text-lg mb-4">Enlaces</h4>
            <ul className="space-y-3">
              {[
                { label: 'Inicio', href: '/' },
                { label: 'Servicios', href: '/#servicios' },
                { label: 'Productos', href: '/#productos' },
                { label: 'Casos de Éxito', href: '/#casos' },
                { label: 'Blog', href: '/blog' },
                { label: 'Contacto', href: '/#contacto' }
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={`#${link.href}`}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="body-small hover:text-[#D4AF37] transition-colors inline-block"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-outfit text-white font-semibold text-lg mb-4">Servicios</h4>
            <ul className="space-y-3">
              <li>
                <a href="#/#servicios" onClick={(e) => handleNavClick(e, '/#servicios')} className="body-small hover:text-[#D4AF37] transition-colors inline-block text-sm">
                  Marketing Digital
                </a>
              </li>
              <li>
                <a href="#/#servicios" onClick={(e) => handleNavClick(e, '/#servicios')} className="body-small hover:text-[#D4AF37] transition-colors inline-block text-sm">
                  Captación de Leads
                </a>
              </li>
              <li>
                <a href="#/#servicios" onClick={(e) => handleNavClick(e, '/#servicios')} className="body-small hover:text-[#D4AF37] transition-colors inline-block text-sm">
                  Experiencia Inmersiva
                </a>
              </li>
              <li>
                <a href="#/#servicios" onClick={(e) => handleNavClick(e, '/#servicios')} className="body-small hover:text-[#D4AF37] transition-colors inline-block text-sm">
                  Software a Medida
                </a>
              </li>
              <li>
                <a href="#/#servicios" onClick={(e) => handleNavClick(e, '/#servicios')} className="body-small hover:text-[#D4AF37] transition-colors inline-block text-sm">
                  Automatización IA
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent mb-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="body-small text-[#888]">
            © {currentYear} Evolvance. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacidad" className="body-small text-[#888] hover:text-[#D4AF37] transition-colors">
              Política de Privacidad
            </Link>
            <Link to="/cookies" className="body-small text-[#888] hover:text-[#D4AF37] transition-colors">
              Política de Cookies
            </Link>
            <Link to="/aviso-legal" className="body-small text-[#888] hover:text-[#D4AF37] transition-colors">
              Aviso Legal
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
